export default __webpack_public_path__ + "static/media/sunflower.d9f81deb.png";